import { post } from "../utils/request";
import { FROM_SIDE, FILTER_WORD } from "../constants";

export const ACCOUNT_MENU_API = "/api/shepherd/auth/opp/account_menu";

// 获取菜单列表
export const getMenu = async () =>
  post(ACCOUNT_MENU_API, {
    fromSide: FROM_SIDE.DENG_TA,
    filterWord: FILTER_WORD.WHOLE_MENU,
  });

// 菜单接口返回数据
export const MENU_RESPONSE_CODE = {
  NO_PERMISSION: 2001,
};

// 默认菜单数据
export const defaultMenuData = {
  account: {
    accountId: "75079902",
    accountType: 1,
  },
  wholeMenu: {
    menus: [
      {
        id: 133928,
        code: "mall.fe.pc_ee0482f7c7e9c32f72ba9e6075fc7dce",
        createTime: 1676280310,
        sort: 254,
        title: "出清管理",
        type: 1,
        url: "smenu://gongyinglian/chuqingguanli",
        secondaryMenus: [
          {
            id: 133929,
            code: "mall.fe.pc_ee0482f7c7e9c32f72ba9e6075fc7dce",
            createTime: 1676280350,
            sort: 9999,
            title: "不动销库存下掉sku清单",
            type: 1,
            url: "/supply/clearManager/offlineDetail.html",
            tertiaryMenus: null,
          },
          {
            id: 133930,
            code: "mall.fe.pc_ee0482f7c7e9c32f72ba9e6075fc7dce",
            createTime: 1676280372,
            sort: 10000,
            title: "不动销库存生成sku清单",
            type: 1,
            url: "/supply/clearManager/generateDetail.html",
            tertiaryMenus: null,
          },
          {
            id: 133931,
            code: "mall.fe.pc_ee0482f7c7e9c32f72ba9e6075fc7dce",
            createTime: 1676280385,
            sort: 10001,
            title: "不动销库存sku生效清单",
            type: 1,
            url: "/supply/clearManager/detailFinal.html",
            tertiaryMenus: null,
          },
        ],
      },
      {
        id: 120930,
        code: "mall.fe.pc__rss__161899708564877",
        createTime: 1618898208,
        sort: 185,
        title: "灯塔-骑手管理",
        type: 1,
        url: "rss-menu://dengta/qishouguanli",
        secondaryMenus: [
          {
            id: 120934,
            code: "mall.fe.pc__rss__161899708564877",
            createTime: 1618898445,
            sort: 0,
            title: "骑手录入",
            type: 1,
            url: "/riders/riderApply.html",
            tertiaryMenus: null,
          },
          {
            id: 120935,
            code: "mall.fe.pc__rss__161899708564877",
            createTime: 1618898479,
            sort: 1,
            title: "骑手日常管理",
            type: 1,
            url: "/riders/list.html",
            tertiaryMenus: null,
          },
          {
            id: 125326,
            code: "mall.fe.pc__rss__161899708564877",
            createTime: 1629958933,
            sort: 2,
            title: "骑手注册线索",
            type: 1,
            url: "/riders/clue.html",
            tertiaryMenus: null,
          },
          {
            id: 125327,
            code: "mall.fe.pc__rss__161899708564877",
            createTime: 1629958982,
            sort: 3,
            title: "线索公海",
            type: 1,
            url: "/riders/pool.html",
            tertiaryMenus: null,
          },
          {
            id: 133305,
            code: "mall.fe.pc__/capacityManager__165564490804037",
            createTime: 1667390122,
            sort: 4,
            title: "骑手离职",
            type: 1,
            url: "/riders/resign.html",
            tertiaryMenus: null,
          },
        ],
      },
      {
        id: 120931,
        code: null,
        createTime: 1618898300,
        sort: 186,
        title: "灯塔-申诉中心",
        type: 1,
        url: "rss-menu://dengta/shensuzhongxin",
        secondaryMenus: [
          {
            id: 120936,
            code: "mall.fe.pc__rss__161900763239719",
            createTime: 1618898506,
            sort: 9999,
            title: "超时/取消申诉",
            type: 1,
            url: "/complaintCenter/timeout.html",
            tertiaryMenus: null,
          },
          {
            id: 120937,
            code: "mall.fe.pc__rss__161900763239719",
            createTime: 1618898528,
            sort: 10000,
            title: "客诉申诉",
            type: 1,
            url: "/complaintCenter/customerComplaint.html",
            tertiaryMenus: null,
          },
          {
            id: 128413,
            code: "mall.fe.pc__rss__161900763239719",
            createTime: 1652409283,
            sort: 10001,
            title: "逆向交接差异单确认",
            type: 1,
            url: "/complaintCenter/diffOrder.html",
            tertiaryMenus: null,
          },
        ],
      },
      {
        id: 120932,
        code: null,
        createTime: 1618898333,
        sort: 187,
        title: "灯塔-任务管理",
        type: 1,
        url: "rss-menu://dengta/renwuguanli",
        secondaryMenus: [
          {
            id: 120938,
            code: "mall.fe.pc__rss__161900764912499",
            createTime: 1618898547,
            sort: 9999,
            title: "任务列表",
            type: 1,
            url: "/task/list.html",
            tertiaryMenus: null,
          },
          {
            id: 120939,
            code: "mall.fe.pc__rss__161900764912499",
            createTime: 1618898564,
            sort: 10000,
            title: "任务明细管理",
            type: 1,
            url: "/task/detailList.html",
            tertiaryMenus: null,
          },
        ],
      },
      {
        id: 123854,
        code: null,
        createTime: 1627011396,
        sort: 191,
        title: "灯塔-配送看板",
        type: 1,
        url: "rss-menu://dengta/peisongkanban",
        secondaryMenus: [
          {
            id: 123856,
            code: "mall.fe.pc__rss__16407689370266",
            createTime: 1627011455,
            sort: 9999,
            title: "商配送数据看板(离线)",
            type: 1,
            url: "/board/delivery.html",
            tertiaryMenus: null,
          },
          {
            id: 134481,
            code: "mall.fe.pc__rss__16407689370266",
            createTime: 1685003196,
            sort: 10000,
            title: "商配送监控看板(实时)",
            type: 1,
            url: "/board/realTimeMonitor.html",
            tertiaryMenus: null,
          },
        ],
      },
      {
        id: 126191,
        code: null,
        createTime: 1636339387,
        sort: 205,
        title: "灯塔-骑手排班/考勤",
        type: 1,
        url: "rss-menu://dengta/qishoupaiban",
        secondaryMenus: [
          {
            id: 126192,
            code: "mall.fe.pc__/capacityManager__165564490804037",
            createTime: 1636339475,
            sort: 9999,
            title: "排班管理",
            type: 1,
            url: "/capacityManager/attendanceManager.html",
            tertiaryMenus: null,
          },
          {
            id: 129293,
            code: "mall.fe.pc__/capacityManager__165564490804037",
            createTime: 1655642662,
            sort: 10000,
            title: "班次/考勤管理",
            type: 1,
            url: "/capacityManager/globalSetting.html",
            tertiaryMenus: null,
          },
          {
            id: 129327,
            code: "mall.fe.pc__/capacityManager__165564490804037",
            createTime: 1655739350,
            sort: 10002,
            title: "考勤统计",
            type: 1,
            url: "/capacityManager/attendanceReport.html",
            tertiaryMenus: null,
          },
          {
            id: 132733,
            code: "mall.fe.pc__/capacityManager__165564490804037",
            createTime: 1663573272,
            sort: 10003,
            title: "出勤看板",
            type: 1,
            url: "/capacityManager/board.html",
            tertiaryMenus: null,
          },
        ],
      },
      {
        id: 126611,
        code: "mall.fe.pc__rss__164059433087815",
        createTime: 1639467353,
        sort: 212,
        title: "灯塔-对账管理",
        type: 1,
        url: "rss-menu://dengta/duizhangguanli",
        secondaryMenus: [
          {
            id: 126612,
            code: "mall.fe.pc__rss__164059433087815",
            createTime: 1639467440,
            sort: 9999,
            title: "对账单列表",
            type: 1,
            url: "/statement/list.html",
            tertiaryMenus: null,
          },
        ],
      },
      {
        id: 126832,
        code: "mall.fe.pc__rss__164136760368182",
        createTime: 1641367727,
        sort: 216,
        title: "灯塔-保险中心",
        type: 1,
        url: "rss-menu://dengta/baoxianzhongxin",
        secondaryMenus: [
          {
            id: 126834,
            code: "mall.fe.pc__rss__164136760368182",
            createTime: 1641368250,
            sort: 9999,
            title: "雇主责任险",
            type: 1,
            url: "/insuranceCenter/liability.html",
            tertiaryMenus: null,
          },
          {
            id: 128219,
            code: "mall.fe.pc_0f2a5639b8194782bc2b3dbfa2efa72c",
            createTime: 1651743255,
            sort: 10000,
            title: "灯塔菜单test",
            type: 1,
            url: "testurlfordengta",
            tertiaryMenus: null,
          },
        ],
      },
      {
        id: 129494,
        code: null,
        createTime: 1656322217,
        sort: 252,
        title: "灯塔-eHR",
        type: 1,
        url: "rss-menu://dengta/ehr",
        secondaryMenus: [
          {
            id: 129495,
            code: "mall.fe.pc__/capacityManager__165564490804037",
            createTime: 1656322357,
            sort: 9999,
            title: "人员管理",
            type: 1,
            url: "/ehr/list.html",
            tertiaryMenus: null,
          },
        ],
      },
      {
        id: 129809,
        code: null,
        createTime: 1657097942,
        sort: 253,
        title: "灯塔-站点管理",
        type: 1,
        url: "rss-menu://dengta/siteManagement",
        secondaryMenus: [
          {
            id: 129810,
            code: "mall.fe.pc__/capacityManager__165564490804037",
            createTime: 1657098073,
            sort: 9999,
            title: "订单监控",
            type: 1,
            url: "/siteManagement/orderMonitor.html",
            tertiaryMenus: null,
          },
          {
            id: 129811,
            code: "mall.fe.pc__/capacityManager__165564490804037",
            createTime: 1657098085,
            sort: 10000,
            title: "三方监控",
            type: 1,
            url: "/siteManagement/partnerMonitor.html",
            tertiaryMenus: null,
          },
        ],
      },
      {
        id: 133185,
        code: null,
        createTime: 1666607372,
        sort: 259,
        title: "灯塔-账户管理",
        type: 1,
        url: "rss-menu://dengta/zhanghuguanli",
        secondaryMenus: [
          {
            id: 133186,
            code: "mall.fe.pc__rss__161900765791168",
            createTime: 1666607449,
            sort: 9999,
            title: "我的账户",
            type: 1,
            url: "/wallet/account.html",
            tertiaryMenus: null,
          },
        ],
      },
      {
        id: 120933,
        code: "mall.fe.pc__rss__161900765791168",
        createTime: 1618898357,
        sort: 260,
        title: "灯塔-薪资管理",
        type: 1,
        url: "rss-menu://dengta/xinziguanli",
        secondaryMenus: [
          {
            id: 132538,
            code: "mall.fe.pc__/capacityManager__165564490804037",
            createTime: 1662019152,
            sort: 1,
            title: "骑手申诉",
            type: 1,
            url: "/payroll/appeal.html",
            tertiaryMenus: null,
          },
          {
            id: 132700,
            code: "mall.fe.pc__rss__161900765791168",
            createTime: 1663059755,
            sort: 2,
            title: "计费方案",
            type: 1,
            url: "/salary/distribution/list.html",
            tertiaryMenus: null,
          },
          {
            id: 132701,
            code: "mall.fe.pc__rss__161900765791168",
            createTime: 1663059768,
            sort: 3,
            title: "工资单",
            type: 1,
            url: "/salary/salaryPayrolls/list.html",
            tertiaryMenus: null,
          },
          {
            id: 132702,
            code: "mall.fe.pc__rss__161900765791168",
            createTime: 1663059782,
            sort: 4,
            title: "发薪任务",
            type: 1,
            url: "/salary/salaryTasks/list.html",
            tertiaryMenus: null,
          },
          {
            id: 132703,
            code: "mall.fe.pc__rss__161900765791168",
            createTime: 1663059794,
            sort: 5,
            title: "付款流水",
            type: 1,
            url: "/salary/salaryRecord/list.html",
            tertiaryMenus: null,
          },
          {
            id: 135270,
            code: "mall.fe.pc__rss__161900765791168",
            createTime: 1697025047,
            sort: 6,
            title: "算薪方案",
            type: 1,
            url: "/finance/cost-rule/mc/rider-salary/list",
            tertiaryMenus: null,
          },
          {
            id: 135295,
            code: "mall.fe.pc__rss__161900765791168",
            createTime: 1697447484,
            sort: 7,
            title: "骑手算薪数据看板",
            type: 1,
            url: "/finance/cost-rule/mc/rider-salary/data-board/list",
            tertiaryMenus: null,
          },
        ],
      },
      {
        id: 133813,
        code: "mall.fe.pc__rss__1674028990333824",
        createTime: 1674028582,
        sort: 263,
        title: "灯塔-质控",
        type: 1,
        url: "rss-menu://dengta/qualityAssurance",
        secondaryMenus: [
          {
            id: 133814,
            code: "mall.fe.pc__rss__1674028990333824",
            createTime: 1674028737,
            sort: 9999,
            title: "判责清单",
            type: 1,
            url: "/qualityAssurance/list/customerComplaint.html",
            tertiaryMenus: null,
          },
          {
            id: 134733,
            code: "mall.fe.pc__rss__168924528429184",
            createTime: 1689240633,
            sort: 10000,
            title: "绿荫行动",
            type: 1,
            url: "/qualityAssurance/list/sampling.html",
            tertiaryMenus: null,
          },
        ],
      },
      {
        id: 133977,
        code: null,
        createTime: 1676892692,
        sort: 266,
        title: "灯塔-配送物资",
        type: 1,
        url: "rss-menu://dengta/peisongwuzi",
        secondaryMenus: [
          {
            id: 133978,
            code: "mall.fe.pc__/capacityManager__165564490804037",
            createTime: 1676893005,
            sort: 9999,
            title: "循环物资管理",
            type: 1,
            url: "/materials/recycledMaterials.html",
            tertiaryMenus: null,
          },
        ],
      },
      {
        id: 134546,
        code: "mall.fe.pc__/capacityManager__165564490804037",
        createTime: 1686657959,
        sort: 292,
        title: "灯塔-违规扣罚",
        type: 1,
        url: "rss-menu://dengta/penalty",
        secondaryMenus: [
          {
            id: 134548,
            code: "mall.fe.pc__/capacityManager__165564490804037",
            createTime: 1686658077,
            sort: 10000,
            title: "扣罚看板",
            type: 1,
            url: "/penalty/board.html",
            tertiaryMenus: null,
          },
          {
            id: 134549,
            code: "mall.fe.pc__/capacityManager__165564490804037",
            createTime: 1686658147,
            sort: 10001,
            title: "扣罚明细",
            type: 1,
            url: "/penalty/list.html",
            tertiaryMenus: null,
          },
        ],
      },
      {
        id: 134990,
        code: null,
        createTime: 1695282621,
        sort: 342,
        title: "灯塔-考核奖惩",
        type: 1,
        url: "rss-menu://dengta/kaohejiangcheng",
        secondaryMenus: [
          {
            id: 134991,
            code: "mall.fe.pc__/capacityManager__165564490804037",
            createTime: 1695282679,
            sort: 9999,
            title: "站点评级结果",
            type: 1,
            url: "/evaluation/siteRatingResult.html",
            tertiaryMenus: null,
          },
          {
            id: 134992,
            code: "mall.fe.pc__/capacityManager__165564490804037",
            createTime: 1695282724,
            sort: 10000,
            title: "站点评级结果明细",
            type: 1,
            url: "/evaluation/siteRatingDetail.html",
            tertiaryMenus: null,
          },
        ],
      },
    ],
  },
  headerMenu: null,
};

export const getDefaultMenuSource = () => defaultMenuData.wholeMenu.menus || [];
